import { useState } from 'react';
import { LOCAL_STORAGE_PREFIX } from '../app.settings';


function parseLocalStorgeKey(key: string): string {
  return '@' + String(LOCAL_STORAGE_PREFIX).toLowerCase() + ':' + key;
}

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      const item = window.localStorage.getItem(parseLocalStorgeKey(key));
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(
        parseLocalStorgeKey(key),
        JSON.stringify(valueToStore)
      );
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue] as const;
};
